export const loadWidget = (merchantId, merchantSiteTitle, externalMountingParams = {}) => {
	if (merchantId === 'all') {
		hideWidget();
		return;
	}

	if (window.SquadAPI) {
		window.SquadAPI.initWidget({
			merchantId,
			merchantSiteTitle,
		});
	} else {
		const ENV = localStorage.getItem('envSquadded');
		const SQUAD_ORIGIN = ENV === 'STAGING' || ENV === 'DEV' ? 'squad-shopping.com' : 'squadded.co';
		const SQUAD_STATIC_ORIGIN = ENV === 'DEV' ? 'https://localhost:3000/widget' : `https://static.${SQUAD_ORIGIN}`;
		const WIDGET_SCRIPT = `${SQUAD_STATIC_ORIGIN}/loader/squad-widget-loader.${ENV === 'DEV' ? 'dev' : 'min'}.js`;
		localStorage.setItem('enableSquaddedWidget', 'true');
		localStorage.setItem('isInDashboard', 'true');
		const { mountingNode, brandColor, handleDesign, handleText, popupMessage, fixPopupMessage } = externalMountingParams;

		if (fixPopupMessage) {
			localStorage.removeItem('squadded-popup-shown');
			sessionStorage.removeItem('squadded-visits-popup');
		} else {
			localStorage.setItem('squadded-popup-shown', Date.now());
		}

		const popupData = {
			Text: popupMessage,
			delay: fixPopupMessage ? 0 : null,
			closeDelay: fixPopupMessage ? 9999999 : null,
		};
		window['__squadded__domain'] = `https://${SQUAD_ORIGIN}`;
		const s = document.createElement('script');
		s.id = 'squad-js';
		s.src = WIDGET_SCRIPT;
		s.setAttribute('data-merchant-id', merchantId);
		s.setAttribute('data-merchant-site-title', merchantSiteTitle); // optional. Default is current document.title
		s.setAttribute('data-is-mono', true);
		s.setAttribute('data-handledesign', handleDesign || 'square');
		s.setAttribute('data-popup', JSON.stringify(popupData));
		s.setAttribute('data-handletext', handleText || 'Community');
		s.setAttribute('data-brand-color', brandColor || '#1e1e2d');
		s.setAttribute('data-is-in-dashboard', true);
		mountingNode ? mountingNode.appendChild(s) : document.body.appendChild(s);
		setTimeout(() => {
			window.dispatchEvent(new Event('pageshow'));
		}, 100);
	}
};

export const openWidgetPost = (postId) => {
	if (!postId) {
		return;
	}
	window.SquadAPI && window.SquadAPI.openPost(postId);
};

export const openAmbassadorChat = (userId, message) => {
	console.log('userId, message', userId, message)
	window.SquadAPI && window.SquadAPI.openAmbassadorChat && window.SquadAPI.openAmbassadorChat(userId, message);
};

export const modifyPost = (postId) => {
	window.SquadAPI && window.SquadAPI.modifyPost && window.SquadAPI.modifyPost(postId);
};

export const openWidgetUser = (userId) => {
	window.SquadAPI && window.SquadAPI.openUserProfile(userId);
};

export const openWidgetChallengePosts = (challengeId, challengeHashtag) => {
	window.SquadAPI && window.SquadAPI.openChallengePosts(challengeId, challengeHashtag);
};

export const requestToken = () => {
	window.SquadAPI && window.SquadAPI.requestToken && window.SquadAPI.requestToken();
};

export const sendQuizPreview = (quiz) => {
	window.SquadAPI && window.SquadAPI.sendQuizPreview && window.SquadAPI.sendQuizPreview(quiz);
};

export const createDraftPost = (socialMediaLink, postTitle, postCreated) => {
	if (postCreated) {
		return;
	}
	window.SquadAPI && window.SquadAPI.createDraftPost({ socialMediaLink, type: 'createDraftPost', postTitle });
};

export const hideWidget = () => {
	const aside = document.querySelector('aside');

	if (aside) {
		aside.style.display = 'none';
		document.body.style.width = 'unset';
	}
};
